module.exports = __webpack_public_path__ + "img/remove-logs.7b243c33.svg";